import './gridStyles.scss';
import classnames from 'classnames';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React, { useEffect } from 'react';
import syncScroll from '~/utils/syncScroll';
import Header from '../header';
import { useComparison } from '../provider';
import GridTable from './grid_table';
import { GridProvider } from './provider';
const GridView = () => {
    const { isInitializing, comparisonDocuments, anchorDocId } = useComparison();
    useEffect(() => {
        syncScroll.reset();
    }, [comparisonDocuments, anchorDocId]);
    if (isInitializing) {
        return React.createElement("div", { className: 'main-content page-content-wrapper', "data-public": true },
            React.createElement("div", { id: 'comparison-grid', className: 'comparison-grid-container' },
                React.createElement(LoadingElement, { isLightBackground: true, text: 'Loading Documents for Comparison...', heading: true })));
    }
    const gridContainerClass = classnames('comparison-grid-container', {
        one: comparisonDocuments.length === 2,
        two: comparisonDocuments.length === 3,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'main-content page-content-wrapper' },
            React.createElement("div", { id: 'comparison-grid', className: gridContainerClass },
                React.createElement(Header, null),
                React.createElement(GridTable, null)))));
};
const GridViewWrapper = () => {
    return React.createElement(GridProvider, null,
        React.createElement(GridView, null));
};
export default GridViewWrapper;
